export default __webpack_public_path__ + "static/media/lower-upper-sample.2cb5bf49.svg";